import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ItemService } from '../../../item.service';
import { IItem, ITEM_TTL_ES } from '../../../item.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-item-update',
  templateUrl: './item-update.component.html'
})
export class ItemUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  changeForm = false;
  select = {
    therapistGroups: {
      type: 'multiple',
      openDialog: false,
      ids: []
    },
    activeIngredients: {
      type: 'multiple',
      openDialog: false,
      ids: []
    }
  };

  constructor(private fb: FormBuilder, private itemService: ItemService) {
    super(ITEM_TTL_ES, itemService);
  }

  ngOnInit() {
    const item = this.row as IItem;
    this.fg = this.fb.group({
      code: [item.code, [Validators.required]],
      name: [item.name, [Validators.required]],
      groupTherapists: [{ value: item.therapistGroups, disabled: true }],
      activeIngredients: [{ value: item.activesIngredients, disabled: true }]
    });
    this.select.therapistGroups.ids = item.therapistGroupsIds;
    this.select.activeIngredients.ids = item.activesIngredientsIds;

    this.fg.valueChanges.subscribe(() => {
      this.changeForm = true;
    });
  }

  onSubmit() {
    if (this.fg.valid && this.changeForm) {
      this.updateItem$(this.parseData(this.fg.value));
    }
  }

  parseData(form) {
    return {
      code: form.code,
      name: form.name,
      groupTherapistsIds: this.select.therapistGroups.ids,
      activeIngredientsIds: this.select.activeIngredients.ids
    };
  }

  onSelectedTherapishGroup(rows) {
    if (rows?.length > 0) {
      this.fg
        .get('groupTherapists')
        .setValue(rows.map((row) => row.description));
      this.select.therapistGroups.ids = rows.map((row) => row.id);
    }
    this.select.therapistGroups.openDialog = false;
  }

  onSelectedActiveIngredients(rows) {
    if (rows?.length > 0) {
      this.fg
        .get('activeIngredients')
        .setValue(rows.map((row) => row.description));
      this.select.activeIngredients.ids = rows.map((row) => row.id);
    }
    this.select.activeIngredients.openDialog = false;
  }
}
